import { render, staticRenderFns } from "./nutrition-detail.html?vue&type=template&id=1db4e8c4&scoped=true&"
import script from "./nutrition-detail.js?vue&type=script&lang=js&"
export * from "./nutrition-detail.js?vue&type=script&lang=js&"
import style0 from "./nutrition-detail.scss?vue&type=style&index=0&id=1db4e8c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db4e8c4",
  null
  
)

export default component.exports